import React from 'react';

const TimelineSearchIcon: React.FC = () => (
  <svg width="74" height="75" viewBox="0 0 74 75" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M64.7906 65.0162L58.141 58.3665L51.4913 51.7169M58.9435 57.564L65.5932 64.2137L63.9881 65.8188L57.3384 59.1691M58.676 34.443C58.676 47.9511 47.7255 58.9016 34.2174 58.9016C20.7093 58.9016 9.75879 47.9511 9.75879 34.443C9.75879 20.9349 20.7093 9.98438 34.2174 9.98438C47.7255 9.98438 58.676 20.9349 58.676 34.443Z"
      stroke="#475467"
      strokeWidth="4.58599"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      opacity="0.4"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.6251 23.2285C24.2924 23.2285 24.8334 23.7695 24.8334 24.4368V40.1452C24.8334 41.8135 26.1859 43.166 27.8542 43.166H45.3751C46.0424 43.166 46.5834 43.707 46.5834 44.3743C46.5834 45.0417 46.0424 45.5827 45.3751 45.5827H27.8542C24.8512 45.5827 22.4167 43.1482 22.4167 40.1452V24.4368C22.4167 23.7695 22.9577 23.2285 23.6251 23.2285Z"
      fill="#00A389"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.8333 39.404L29.8819 33.8505L33.2204 35.9371C34.0847 36.4772 35.2112 36.3241 35.8999 35.5728L42.0365 28.8784C42.4874 28.3864 42.4542 27.6221 41.9623 27.1711C41.4703 26.7202 40.706 26.7534 40.255 27.2454L34.2882 33.7546L30.9488 31.6675C30.0818 31.1256 28.9512 31.2817 28.2634 32.0382L24.8333 35.8114V39.404Z"
      fill="#10A890"
    />
  </svg>
);

export default TimelineSearchIcon;
